module.exports = __webpack_public_path__ + "static/media/selfie-icon.fc5190f2.svg";